<template>
	<div :class="['c-toggle', { active: !showSidebar }]">
		<a href="#" @click.prevent="onToggle">
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M11 5H4C3.44772 5 3 5.44772 3 6V18C3 18.5523 3.44772 19 4 19H11M11 5H20C20.5523 5 21 5.44772 21 6V18C21 18.5523 20.5523 19 20 19H11M11 5V19"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="square"
					stroke-linejoin="round"
				/>
			</svg>
			<!-- <span> Library </span> -->
		</a>
	</div>
</template>

<script>
export default {
	computed: {
		showSidebar: function () {
			return this.$store.getters['app/showSidebar'];
		},
	},

	methods: {
		onToggle: function () {
			this.$store.dispatch('app/toggleSidebar');
		},
	},
};
</script>

<style lang="scss">
.c-toggle {
	position: absolute;
	z-index: 999;
	top: 6px;
	left: 6px;
	padding: 6px;
	border-radius: calc(var(--margin-sm) + 6px);
	background-color: var(--color-bg-97);
	font-size: 14px;
	box-shadow: 0px 0px 0.5px rgba(0, 0, 0, 0.5), 0px 1px 3px rgba(0, 0, 0, 0.4),
		inset 0px 0.5px 0px rgba(255, 255, 255, 0.1),
		inset 0px 0px 0.5px rgba(255, 255, 255, 0.3);

	transform: translateX(-100px);

	opacity: 0;

	a {
		display: flex;
		align-items: center;
		padding: var(--margin-sm);
		color: var(--color-button-font);
		text-decoration: none !important;
		line-height: 1;
		border-radius: var(--margin);

		&:hover,
		&:active {
			background-color: rgba(255, 255, 255, 0.1);
		}
	}

	&.active {
		transform: translateX(0);
		opacity: 1;
	}

	svg {
		width: 20px;
		height: 20px;
		//margin-right: var(--margin);
	}

	@include media-breakpoint-down(sm) {
		transform: translateX(0);
		opacity: 1;

		&.active {
			transform: translateX(-100px);
			opacity: 0;
		}
	}
}
</style>
